<template>
  <ErrorModal />
  <div class="rate-limit-logs-tab-content">
    <DxDataGrid
      :data-source="rateLimitingLogs"
      :remote-operations="true"
      :key-expr="'conversationId'"
      :show-borders="true"
      :allow-column-resizing="true"
      column-resizing-mode="widget"
      no-data-text="No results"
      @exporting="onExporting"
    >
      <DxExport :enabled="true" />

      <DxColumn
        data-field="userId"
        data-type="string"
        caption="User ID"
        :allow-sorting="false"
      />
      <DxColumn
        data-field="username"
        data-type="string"
        caption="Username"
        :allow-sorting="false"
      />
      <DxColumn
        data-field="rateLimitReachedAt"
        data-type="Date"
        caption="Rate limit reached at"
        :allow-sorting="false"
        cell-template="rateLimitReachedAtCellTemplate"
      />
      <template #rateLimitReachedAtCellTemplate="rowData">
        <span>{{
          moment(rowData.data.data.rateLimitReachedAt).format(
            "MMMM Do YYYY, h:mm:ss A"
          )
        }}</span>
      </template>
      <DxColumn
        data-field="ipAddress"
        data-type="string"
        caption="IP Address"
        :allow-sorting="false"
      />
      <DxColumn
        data-field="permitLimit"
        data-type="number"
        caption="Limit"
        :allow-sorting="false"
      />
      <DxPaging :page-size="10" />
      <DxPager
        :visible="true"
        :allowed-page-sizes="[10, 20, 50, 'all']"
        display-mode="full"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="true"
      />
      <DxLoadPanel :enabled="true" />
    </DxDataGrid>
  </div>
</template>
<script setup>
import { ref } from "vue";
import moment from "moment";
import {
  DxDataGrid,
  DxPager,
  DxPaging,
  DxColumn,
  DxLoadPanel,
  DxExport
} from "devextreme-vue/data-grid";
import ErrorModal from "../ErrorModal.vue";
import createCustomStore from "../../../store/custom.store";
import aiService from "../../../services/ai.service";
const rateLimitingLogs = ref(
  createCustomStore(
    "/api/aiAssistantLogs/getRateLimitingLogs",
    null,
    "conversationId"
  )
);

const onExporting = async e => {
  await aiService
    .exportRateLimitLogs()
    .then(response => {
      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        })
      );
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      a.href = fileURL;
      a.download = "RateLimitLogs.xlsx";
      a.click();
      window.URL.revokeObjectURL(fileURL);
      document.body.removeChild(a);
    })
    .catch(error => {
      console.error("Error downloading the file:", error);
    });
};
</script>
